import axios from 'axios'

export default {
  namespaced: true,

  state: {
    user: null,
    token: null
  },

  mutations: {
    token_set (state, token) {
      state.token = token
    },
    // записать токен в хранилище
    token_store (_state, token) {
      sessionStorage.setItem('token', token)
    },
    // сброс и удаление токена
    token_reset (state) {
      state.token = null
      sessionStorage.removeItem('token')
    },

    // установка пользователя
    user_set (state, user) {
      state.user = user
    },
    // сброс пользователя
    user_reset (state) {
      state.user = null
    }
  },

  actions: {
    // установить токен и сохранить его в хранилище
    setToken ({ commit }, token) {
      commit('token_set', token)
      commit('token_store', token)
    },

    // восстановление токена из хранилища
    restoreToken ({ commit }) {
      const token = sessionStorage.getItem('token')
      commit('token_set', token)
    },

    // вход в систему - получение токена / аутентификация
    async login ({ dispatch }, { login, password }) {
      await axios
        .post('/auth/login', { login, password })
        .then((response) => {
          dispatch('setToken', response.data.token)
            . then(() => dispatch('setUser'))
        })
    },

    // получение данных пользователя
    async setUser ({ commit }) {
      await axios
        .get('/auth/CurrentUser')
        .then((response) => {
          commit('user_set', response.data)
        })
    },

    // выход из системы
    logout ({ commit }) {
      commit('token_reset')
      commit('user_reset')
    }
  }
}
